import { Typography } from "@mui/material";

export type EManifestBox18a = { text?: string | null; appliesToLine: boolean };

/** Under an e-Manifest quantity: the receiving facility ticked Box 18a Quantity and wrote the real amount. */
export function EManifestBox18aCaption({ box18a }: { box18a: EManifestBox18a | null | undefined }) {
  if (!box18a) return null;
  return (
    // pre-line keeps the line breaks ingest puts between each waste line's text.
    <Typography variant="caption" color="warning.main" display="block" whiteSpace="pre-line">
      Box 18a: quantity discrepancy
      {box18a.text ? ` "${box18a.text}"` : ""}
      {box18a.appliesToLine ? "" : " (applies to the whole manifest)"}
    </Typography>
  );
}
